<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200 } = $AppState.theme.colors;
</script>

<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 10.875V18.975C4 19.5121 4.21335 20.0271 4.59311 20.4069C4.97287 20.7867 5.48794 21 6.025 21H18.175C18.7121 21 19.2271 20.7867 19.6069 20.4069C19.9866 20.0271 20.2 19.5121 20.2 18.975V10.875"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16.1508 7.05L12.1008 3L8.05078 7.05"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12.0996 3V12.7875"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
